import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardTitle, CardText, Button } from "reactstrap";
import { Link } from "react-router-dom";
import ResponsivePicture from "../ResponsivePicture";
import LazyLoad from "react-lazyload";
import { REACT_APP_SHOP_CDN_SERVER } from "../../utils/env";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";

const ShopTaxonCard = (props, context) => {
  const { titleTag, taxonId, wide } = props;

  const { lang, shopTaxons, taxonsImages } = useSelector((state) => ({
    lang: state.i18nState.lang,
    shopTaxons: state.shopTaxons.taxonsDictionary[state.i18nState.lang],
    taxonsImages: state.shopTaxons.taxonsImages,
  }));

  const taxonData = shopTaxons ? shopTaxons[taxonId] : null;
  const dispatch = useDispatch();
  const handleClick = (event) => {
    event.preventDefault();
    dispatch(
      push(
        `/${lang}/t/${taxonData?.attributes?.permalink.replace("shop/", "")}/`
      )
    );
  };

  const hostPrefix = REACT_APP_SHOP_CDN_SERVER || "https://sdn.myfolie.com";

  const taxonThumbnail = taxonData?.attributes?.preview_image?.url
    ? taxonData?.attributes?.preview_image
    : wide
    ? taxonsImages[taxonData?.relationships?.image?.data?.id]?.attributes
        ?.styles[2]
    : taxonsImages[taxonData?.relationships?.image?.data?.id]?.attributes
        ?.styles[2];
  const imgSrcs = taxonThumbnail
    ? `${hostPrefix}${taxonThumbnail.url} ${
        (taxonThumbnail.width || "640") + "w" || "640w"
      }`
    : "";

  const renderImage = (external) => {
    const component = (
      <LazyLoad>
        <ResponsivePicture
          mediumData={{
            url: imgSrcs,
            metadata: {
              width: 600,
              height: 400,
            },
          }}
          skipLazyLoading={wide}
          className="card-img-top"
          altTitle={taxonData?.attributes?.name}
        />
      </LazyLoad>
    );
    return (
      <Link
        to={`/${lang}/t/${taxonData?.attributes?.permalink.replace(
          "shop/",
          ""
        )}/`}
      >
        {component}
      </Link>
    );
  };

  return taxonData ? (
    <Card
      className={`shop-product-card h-100 ${wide ? "row" : ""}`}
      style={wide ? { flexDirection: "row" } : {}}
      onClick={handleClick}
    >
      <div className={wide ? "col-12 col-md-6" : ""}>{renderImage()}</div>
      <div className={wide ? "col-12 col-md-6" : ""}>
        <CardBody>
          <CardTitle className="h5" tag={titleTag}>
            {taxonData?.attributes?.name}
          </CardTitle>
          <CardText
            className="text-secondary"
            style={{ whiteSpace: "pre-line", fontSize: "90%" }}
            dangerouslySetInnerHTML={{
              __html: taxonData?.attributes?.preview_description,
            }}
          />
          <div className="text-right">
            <Button size="sm" color="link">
              {context.t("view products")}
            </Button>
          </div>
        </CardBody>
      </div>
    </Card>
  ) : (
    <></>
  );
};

ShopTaxonCard.contextTypes = {
  t: PropTypes.func,
};

ShopTaxonCard.propTypes = {
  titleTag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

export default ShopTaxonCard;
